import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { useFolder } from '../../context/folder-context';

import Container from '../../components/blocks/container';
import NavigateFooter from '../../components/folder-components/folder--navigate-footer';
import AppointmentSignatures from '../../components/folder-components/signatures/folder--signatures--info';
import PaymentsOverview from '../../components/folder-components/payments/folder--payments--overview';

/**
 * PaymentsAndSignaturePage Component
 *
 * Displays payments and signature details for a folder,
 * and controls navigation based on signature completion.
 */
const PaymentsAndSignaturePage = () => {
  const { refFolder } = useParams();
  const navigate = useNavigate();
  const { title, color } = useFolder();

  // Will be set to true by AppointmentSignatures when signature completed
  const [unlocked, setUnlocked] = useState(false);

  return (
    <Container
      className="folder-container"
      title={title || ''}
      titleBackground={color || 'transparent'}
    >
      {/* Signature Section */}
      <AppointmentSignatures setUnlocked={setUnlocked} />

      {/* Payments Section */}
      <PaymentsOverview showEditButton={true} />

      {/* Navigation footer */}
      {unlocked ? (
        <NavigateFooter
          onBack={() => navigate(`/folders/${refFolder}/parts`)}
          onNext={() => navigate(`/folders/${refFolder}/overview/`)}
        />
      ) : (
        <NavigateFooter
          onBack={() => navigate(`/folders/${refFolder}/parts`)}
        />
      )}
    </Container>
  );
};

export default PaymentsAndSignaturePage;
